import React from 'react';

export const WorkUnitsViewCardSkeleton = () => {
  return (
    <div className="w-full mt-0 !py-0">
      <div className="block cursor-pointer">
        {/* Mirroring the card structure: flex col, border-left (simulated), overflow hidden */}
        <div 
          className="flex flex-col overflow-hidden animate-pulse"
        >
          {/* Content padded similarly to the card */}
          <div className="flex-1 flex flex-col relative">
            
            {/* ROW 1: Header -> Icon + Type + Stage */}
            <div className="flex items-center py-2 px-2">
              {/* Entity Icon (ProgressCircle placeholder) */}
              <div className="rounded-lg flex items-center justify-center flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-gray-700" />
              </div>

              {/* Unit Header Content */}
              <div className="flex flex-col py-1 ml-2 w-full space-y-2">
                {/* Title */}
                <div className="h-3.5 bg-gray-200 dark:bg-gray-700 rounded w-3/4" />
                
                {/* Type + Count + Stage */}
                <div className="flex items-center gap-2">
                  {/* Icon + Label */}
                  <div className="h-2.5 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
                  
                  {/* Count Badge placeholder */}
                  <div className="h-2.5 bg-gray-200 dark:bg-gray-700 rounded w-8" />
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};
